var _circle, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 84,
    viewBox: "0 0 89 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#06101F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 51,
    width: 27.76,
    height: 27.76,
    rx: 13.88,
    fill: "#06101F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.88 59V70.76M69 64.88H80.76",
    stroke: "#01C2F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60C58 57.2089 58 55.8133 57.6555 54.6777C56.8799 52.1209 54.8791 50.1201 52.3223 49.3445C51.1867 49 49.7911 49 47 49H37C34.2089 49 32.8133 49 31.6777 49.3445C29.1209 50.1201 27.1201 52.1209 26.3445 54.6777C26 55.8133 26 57.2089 26 60M51 33C51 37.9706 46.9706 42 42 42C37.0294 42 33 37.9706 33 33C33 28.0294 37.0294 24 42 24C46.9706 24 51 28.0294 51 33Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.24f1528f8cb51d8f7d66c3e048f699f2.svg";
export { ForwardRef as ReactComponent };